import { FaExclamationTriangle } from 'react-icons/fa';
import { ScreenState } from './ScreenState';
import { useLanguage } from '../../../Hooks/Contexts/Translate/useLanguageContext';

const BLOCK = 'LStudio__app_screen';

/*
    🔥 ERROR

    El compañero visual de AppErrorBoundary: el boundary ATRAPA, esta
    pantalla MUESTRA. Separarlos permite usar la misma cara para un
    fallo de red que no rompió nada.

    ⚠️ EL STACK SOLO EN DESARROLLO

    Un stack en producción filtra rutas del servidor y nombres internos,
    y al usuario no le dice nada. En desarrollo, en cambio, ahorra ir a
    la consola.

    ⚠️ "REINTENTAR" ANTES QUE "RECARGAR"

    Si el padre pasa onRetry, se vuelve a pedir el dato sin perder el
    estado de la pantalla. Recargar entero es el último recurso.
*/

export const ScreenError = ({
    title = null,
    description = null,
    error = null,
    isDetailed = process.env.NODE_ENV === 'development',
    onRetry = null,
    retryLabel = null,
    isFullScreen = false,
}) => {

    const { useDataLanguage } = useLanguage();

    const TEXT = useDataLanguage.translations?.TEMPLATES?.screen ?? {};
    const COMMON = useDataLanguage.translations?.TEMPLATES?.common ?? {};

    return (
        <ScreenState
            icon={<FaExclamationTriangle />}
            tone="danger"
            title={title ?? TEXT.errorTitle}
            description={description ?? TEXT.errorText}
            isFullScreen={isFullScreen}
            actions={
                <>
                    {
                        typeof onRetry === 'function' && (
                            <button type="button" className={`${BLOCK}__button`} onClick={onRetry}>
                                {retryLabel ?? COMMON.retry}
                            </button>
                        )
                    }

                    <button type="button" className={`${BLOCK}__button ${BLOCK}__button--ghost`}
                        onClick={() => window.location.reload()} >
                        {TEXT.reload}
                    </button>
                </>
            }
        >
            {
                isDetailed && error && (
                    <pre className={`${BLOCK}__detail`}>
                        {error?.stack ?? error?.message ?? String(error)}
                    </pre>
                )
            }
        </ScreenState>
    );
};
